<template>
<van-overlay :show="isShow">
    <div class="wrapper" @click.stop>
        <div class="block">
            <van-loading type="spinner" />
        </div>
    </div>
</van-overlay>
</template>

<script>
export default {
    name: "loadingMask",
    props: ['isShow'],
    data() {
        return {};
    },
    methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.block {
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/loadingMask.vue